// window.environment is set by public/config.js, a separate <script> the deploy
// substitutes env values into. If that request fails or is served stale/empty,
// this module must still evaluate — a throw here happens before any boundary
// exists and takes the whole app to a white screen. Screens already handle
// missing keys; they cannot handle not loading at all.
export default window.environment || {};
